import React from "react";

import { Link } from "react-router-dom";
import { routes } from "../../services/routes";

export default function PizzaIcon(props) {
  return (
    <>
      <svg x="0px" y="0px" viewBox="0 0 394.877 394.877" className={props.svg}>
        <g transform="matrix(-1.83697e-16 1 -1 -1.83697e-16 394.877 0)">
          <g>
            <g>
              <path
                d="M383.145,152.382c-1.024-1.536-2.048-3.072-3.584-3.584c1.536-2.048,2.56-5.12,2.048-7.68    c-0.512-11.264-5.632-34.304-30.72-62.976c-25.6-28.672-48.128-36.352-58.88-38.4c-2.048-0.512-3.584,0-5.12,0    c-0.512-2.56-2.048-5.12-4.096-6.656c-8.704-7.168-29.184-18.432-67.584-18.432c-38.4,0-58.88,11.776-68.096,18.432    c-4.608,3.584-6.144,9.216-3.584,14.336l8.192,18.944l51.2,123.904c0,0.512,0.512,1.024,1.024,1.536    c-1.024-0.512-2.56-0.512-4.096-0.512L65.193,203.07l-20.48,1.536c-5.632,0.512-10.24,4.608-11.264,10.24    c-2.048,11.264-2.56,34.816,15.872,68.096c17.92,33.792,38.4,46.08,48.64,50.688c1.536,0.512,3.072,1.024,5.12,1.024    c0,0,0,0,0.512,0c0,2.56,1.024,5.12,2.56,7.68c7.168,8.704,24.064,25.088,61.44,33.792c13.312,3.072,24.576,4.096,34.304,4.096    c17.408,0,29.184-3.584,35.84-6.656c1.536-0.512,3.072-2.048,4.096-3.072c2.048,1.536,4.608,3.072,7.168,3.072    c1.024,0,2.048,0,3.072,0c12.288,0,34.304-3.584,62.464-23.552c31.232-22.016,41.472-43.52,45.056-54.272    c0.512-1.536,0.512-3.584,0.512-5.12c2.56-0.512,5.12-1.536,7.168-3.584c8.192-8.192,22.016-27.136,26.112-65.024    C398.505,184.126,389.289,162.11,383.145,152.382z M287.401,51.006c0.512-1.024,1.536-1.536,2.048-1.024    c9.728,2.048,30.208,8.704,53.248,34.816c23.04,26.112,27.648,46.592,28.16,56.832c0,1.024-0.512,1.536-1.536,2.048l-8.192,3.072    c-1.024-10.24-6.144-29.696-27.136-53.76c-20.992-24.064-40.448-31.232-50.688-33.28L287.401,51.006z M361.641,218.43    c-3.584,31.232-15.36,46.08-20.48,51.2c-0.512,0.512-1.024,0.512-1.536,0l-59.904-34.816l-52.736-33.28l59.904-19.968    l65.024-18.432c0.512,0,1.024,0,1.536,0.512C357.545,169.79,365.225,187.198,361.641,218.43z M280.233,69.438    c6.656,1.024,25.088,6.656,46.592,30.72c20.992,23.552,24.064,42.496,24.576,49.152c0,0.512-0.512,1.024-1.024,1.024    l-66.048,21.504l-59.904,16.896l25.088-57.856l29.696-60.928C279.209,69.438,279.721,69.438,280.233,69.438z M152.233,43.838    c-0.512-1.024,0-2.048,0.512-2.56c8.192-6.144,26.624-16.384,61.44-16.384s53.248,10.24,60.928,16.384    c0.512,0.512,1.024,1.536,0.512,2.56l-3.584,8.192c-8.704-6.144-26.112-15.36-57.856-15.36s-50.176,9.216-58.368,15.36    L152.233,43.838z M160.425,62.782c0-0.512,0-1.024,0.512-1.536c5.632-4.096,22.016-14.336,53.76-14.336    c30.72,0,46.592,8.704,53.248,14.336c0.512,0.512,0.512,1.024,0.512,1.536l-27.648,64l-28.672,59.392L160.425,62.782z     M213.161,197.95c0,0.512,0,0.512,0,1.024c0,0-0.512,0-1.024,0.512c-0.512,0-0.512,0-1.024-0.512c0-0.512,0-1.024-0.512-1.536    l-0.512-0.512c0.512,0,1.536,0.512,2.048,0.512C212.649,197.95,212.649,197.95,213.161,197.95z M207.017,213.31l12.8,61.952    l10.752,66.56c0,0.512,0,1.024-0.512,1.536c-6.144,3.072-24.576,8.704-55.296,1.536c-30.72-7.168-44.032-20.48-48.64-26.112    c-0.512-0.512-0.512-1.024,0-1.536l41.472-55.808L207.017,213.31z M104.617,323.902c-0.512,0.512-1.536,1.024-2.56,0.512    c-7.168-3.072-26.624-14.336-44.032-46.592c-16.384-30.72-16.384-51.712-14.336-61.44c0-1.024,1.024-1.536,2.048-1.536    l9.216-0.512c-1.536,10.24-1.024,30.72,13.824,58.368c15.36,28.16,31.744,39.424,41.472,44.032L104.617,323.902z M77.481,268.094    c-14.848-27.648-13.824-46.592-12.8-53.76c0-0.512,0.512-1.024,1.024-1.024l134.144-11.264c-0.512,0.512-1.024,0.512-1.024,1.024    l-38.912,52.224l-42.496,52.736c-0.512,0.512-1.024,0.512-1.536,0.512C109.225,305.47,92.841,295.742,77.481,268.094z     M233.129,364.35c-7.168,3.584-28.16,10.24-64,2.048c-34.304-8.192-49.664-22.528-55.808-30.208c-0.512-0.512-0.512-1.536,0-2.56    l5.632-7.168c6.656,8.192,22.016,20.992,52.736,28.16c11.776,2.56,21.504,3.584,30.208,3.584c14.336,0,24.064-3.072,30.208-5.632    l1.536,9.216C234.665,363.326,234.153,364.35,233.129,364.35z M243.881,341.31l-13.824-68.096l-10.24-61.44l54.784,31.744    l56.832,36.352c0.512,0.512,0.512,1.024,0.512,1.536c-2.048,6.656-9.728,24.064-35.84,42.496    c-26.112,17.92-44.544,19.456-51.712,18.944C244.393,342.334,243.881,342.334,243.881,341.31z M308.905,341.822    c-28.672,19.968-49.664,22.016-59.392,21.504c-1.024,0-1.536-0.512-2.048-1.536l-1.536-9.216c0.512,0,0.512,0,1.024,0    c10.752,0,30.208-3.072,55.296-20.48c26.112-18.432,35.84-36.352,38.912-46.08l7.68,4.608c1.024,0.512,1.024,1.536,1.024,2.56    C347.817,300.862,339.113,320.83,308.905,341.822z M383.657,220.99c-4.096,34.816-16.384,51.712-23.552,58.88    c-0.512,0.512-1.536,1.024-2.56,0.512l-7.68-4.608c7.168-7.68,18.432-24.576,22.016-55.808    c3.584-31.744-3.584-50.688-8.704-59.904l8.704-2.56c1.024-0.512,2.048,0,2.56,1.024    C379.561,166.718,387.753,186.174,383.657,220.99z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M236.201,57.662c-10.24,0-18.432,8.192-18.432,18.432s8.192,18.432,18.432,18.432s18.432-8.192,18.432-18.432    S246.441,57.662,236.201,57.662z M236.201,84.798c-4.608,0-8.192-3.584-8.192-8.192s3.584-8.192,8.192-8.192    c4.608,0,8.192,3.584,8.192,8.192S240.809,84.798,236.201,84.798z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M212.137,100.158c-9.728,0-17.408,7.68-17.408,17.408c0,9.728,7.68,17.408,17.408,17.408    c9.728,0,17.408-7.68,17.408-17.408C229.545,107.838,221.865,100.158,212.137,100.158z M211.625,124.734    c-4.096,0-7.168-3.072-7.168-7.168c0-4.096,3.072-7.168,7.168-7.168s7.168,3.072,7.168,7.168    C218.793,121.662,215.721,124.734,211.625,124.734z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M303.273,99.646c-5.632-6.144-15.36-6.656-21.504-1.024c-3.072,2.56-4.608,6.656-5.12,10.24    c0,4.096,1.024,8.192,3.584,10.752c2.56,3.584,6.656,5.632,10.752,5.632c0.512,0,0.512,0,1.024,0c3.584,0,7.168-1.536,10.24-4.096    C308.393,115.518,308.905,105.79,303.273,99.646z M294.569,114.494c-1.024,1.024-2.048,1.536-3.584,1.024    c-1.536,0-2.56-0.512-3.584-1.536c-1.024-1.024-1.536-2.048-1.024-3.584c0.512-1.536,1.024-3.072,2.048-3.584    c1.024-1.024,2.048-1.024,3.072-1.024c1.536,0,2.56,0.512,3.584,1.536C297.129,109.374,296.617,112.446,294.569,114.494z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M344.745,225.086c-3.584-3.584-7.68-6.144-12.288-6.656c-9.728-1.024-18.944,6.144-19.968,15.872    c-1.024,9.728,6.144,18.944,15.872,19.968c0.512,0,1.536,0,2.048,0c9.216,0,16.896-6.656,17.92-15.872    C348.841,233.79,347.305,228.67,344.745,225.086z M329.385,244.542c-4.608-0.512-7.68-4.608-7.168-8.704    c0.512-4.608,4.608-7.68,8.704-7.168c2.048,0,4.096,1.536,5.12,3.072c1.024,1.536,2.048,3.584,2.048,5.632    C337.577,241.982,333.481,245.054,329.385,244.542z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M349.353,179.006c-2.048-3.072-5.632-5.12-9.728-5.632c-4.096-0.512-8.192,0.512-11.264,3.072    c-3.072,2.56-5.12,6.144-5.632,10.24c-0.512,4.096,0.512,8.192,3.072,11.264c2.56,3.072,6.144,5.12,10.24,5.632    c0.512,0,1.024,0,1.536,0c3.584,0,6.656-1.024,9.216-3.072c3.072-2.56,5.12-6.144,5.632-10.24S351.913,182.078,349.353,179.006z     M340.649,192.318c-1.024,1.024-2.56,1.024-3.584,1.024c-1.536,0-2.56-1.024-3.072-2.048c-1.024-1.024-1.024-2.56-1.024-3.584    c0-1.536,1.024-2.56,2.048-3.072c1.024-1.024,2.56-1.024,3.584-1.024c1.536,0,2.56,1.024,3.072,2.048    c0.512,1.024,1.024,2.56,1.024,3.584S341.673,191.806,340.649,192.318z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M272.553,254.27c-3.072-4.096-6.656-6.656-11.264-7.168c-4.608-1.024-9.216,0-13.312,3.072    c-7.68,5.632-9.728,16.384-4.096,24.576c3.072,4.608,8.704,7.168,14.336,7.168c3.584,0,7.168-1.024,10.24-3.072    c4.096-2.56,6.656-6.656,7.168-11.264C276.649,262.974,275.625,258.366,272.553,254.27z M265.385,266.046    c-0.512,2.048-1.536,3.584-3.072,4.608c-3.072,2.56-7.68,1.536-10.24-2.048c-2.048-3.072-1.536-7.68,2.048-10.24    c3.072-2.048,7.68-1.536,10.24,2.048C265.385,261.95,265.897,263.998,265.385,266.046z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M199.849,299.326c-4.096-1.024-8.192-0.512-11.264,2.048c-3.584,2.048-5.632,5.632-6.656,9.216    c-2.56,8.192,2.56,16.384,10.752,18.432c1.024,0.512,2.56,0.512,3.584,0.512c6.656,0,13.312-4.608,14.848-11.776    C213.161,309.566,208.041,301.374,199.849,299.326z M200.361,315.71c-0.512,2.56-3.072,4.096-6.144,3.584    c-1.536-0.512-2.56-1.024-3.072-2.048c-0.512-1.024,0-2.56,0-4.096c0.512-1.536,1.024-2.56,2.048-3.072    c1.024-0.512,1.536-0.512,2.56-0.512c0.512,0,1.024,0,1.024,0C199.337,310.078,200.873,312.638,200.361,315.71z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M109.225,226.11c-4.608-8.704-15.872-12.288-24.576-7.168c-8.704,4.608-12.288,15.872-7.168,24.576    c3.072,6.144,9.728,9.728,15.872,9.728c3.072,0,5.632-0.512,8.704-2.048C110.761,246.078,113.833,234.814,109.225,226.11z     M96.937,241.982c-4.096,2.048-8.704,0.512-10.752-3.072c-2.048-4.096-0.512-8.704,3.072-10.752    c4.096-2.048,8.704-0.512,10.752,3.072C102.057,234.814,100.521,239.934,96.937,241.982z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M156.329,228.158c-2.048-4.096-6.144-7.168-10.24-8.704c-4.608-1.536-9.216-1.024-13.312,1.536    c-4.096,2.048-7.168,6.144-8.704,10.24c-1.536,4.608-1.024,9.216,1.536,13.312c2.048,4.608,5.632,7.68,10.24,8.704    c1.536,0.512,3.584,0.512,5.12,0.512c3.072,0,5.632-0.512,8.192-2.048c4.096-2.048,7.168-6.144,8.704-10.24    C159.401,236.862,158.889,232.254,156.329,228.158z M144.041,243.006c-1.536,1.024-3.584,1.024-5.632,0.512    c-2.048-0.512-3.584-2.048-4.096-3.584s-1.024-3.584-0.512-5.632c0.512-2.048,2.048-3.584,3.584-4.096    c1.536-1.024,3.584-1.024,5.632-0.512c2.048,0.512,3.584,2.048,4.096,3.584C149.161,236.862,147.625,241.47,144.041,243.006z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M175.273,156.478L92.841,49.982l-12.8-16.384c-3.584-4.608-9.216-6.144-14.336-3.584    c-10.24,4.608-30.208,16.896-48.64,50.176s-17.92,57.344-16.384,68.608c1.024,5.632,5.12,9.728,10.752,10.24l20.48,1.536    l133.12,14.336c1.024,0,1.536,0,1.536,0c4.096,0,7.68-2.048,9.728-5.632C178.345,165.182,178.345,160.574,175.273,156.478z     M21.673,149.822l-8.704-1.024c-1.024,0-1.536-1.024-2.048-1.536c-1.536-9.728-1.536-31.232,14.848-61.952    c16.896-30.72,34.816-41.984,43.52-45.568c1.024-0.512,2.048,0,2.56,0.512l5.632,7.168c-9.728,4.608-26.112,15.872-41.472,43.52    C20.649,119.102,20.137,139.07,21.673,149.822z M168.105,164.158c-0.512,0.512-0.512,0.512-1.024,0.512l-133.12-14.336    c-1.024,0-1.536-0.512-1.536-1.024c-1.024-7.168-2.048-26.112,13.312-53.76c15.36-27.648,31.744-36.864,37.888-39.936    c0.512,0,1.024,0,1.536,0.512l82.944,106.496C168.617,163.134,168.617,163.646,168.105,164.158z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M98.985,85.31c-1.536-4.608-4.608-8.704-8.704-10.752c-4.096-2.56-9.216-3.072-13.824-1.536    c-4.608,1.536-8.704,4.608-10.752,8.704c-2.56,4.096-3.072,9.216-1.536,13.824c1.536,4.608,4.608,8.704,8.704,11.264    c2.56,1.536,5.632,2.048,8.704,2.048c6.656,0,12.8-3.584,15.872-9.728C100.009,95.038,100.521,89.918,98.985,85.31z     M88.233,94.526c-2.048,4.096-7.168,5.12-10.752,3.072c-2.048-1.024-3.072-2.56-3.584-4.608c-0.512-2.048,0-4.096,1.024-6.144    c1.024-2.048,2.56-3.072,4.608-3.584c0.512,0,1.536-0.512,2.048-0.512c1.536,0,2.56,0.512,3.584,1.024    c2.048,1.024,3.072,2.56,3.584,4.608C89.257,90.43,89.257,92.478,88.233,94.526z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M107.177,121.662c-7.168-5.12-16.384-2.56-20.48,5.12c-2.048,3.584-2.56,7.68-1.024,11.776    c1.024,4.096,3.584,7.168,7.168,9.216c2.048,1.024,4.608,2.048,7.168,2.048c1.536,0,3.072,0,4.096-0.512    c4.096-1.024,7.168-3.584,9.216-7.168C117.417,134.974,114.857,125.758,107.177,121.662z M104.617,135.998    c-1.536,2.56-4.096,3.072-6.656,2.048c-1.024-0.512-2.048-1.536-2.56-3.072c-0.512-1.536,0-2.56,0.512-3.584    c0.512-1.024,1.536-2.048,3.072-2.56c0,0.512,0.512,0,1.024,0c1.024,0,1.536,0,2.56,0.512    C105.129,130.878,105.641,133.438,104.617,135.998z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M63.657,128.83l-6.144-12.8c-1.024-2.56-4.096-3.584-6.656-2.56c-2.56,1.024-3.584,4.096-2.56,6.656l6.144,12.8    c1.024,2.048,2.56,3.072,4.608,3.072c0.512,0,1.536,0,2.048-0.512C63.657,134.462,64.681,131.39,63.657,128.83z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M198.825,87.358l-6.144-12.8c-1.024-2.56-4.096-3.584-6.656-2.56c-2.56,1.024-3.584,4.096-2.56,6.656l6.144,12.8    c1.024,2.048,2.56,3.072,4.608,3.072c0.512,0,1.536,0,2.048-0.512C198.825,92.99,200.361,89.918,198.825,87.358z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M288.937,151.358l-6.144-12.8c-1.024-2.56-4.096-3.584-6.656-2.56c-2.56,1.024-3.584,4.096-2.56,6.656l6.144,12.8    c1.024,2.048,2.56,3.072,4.608,3.072c0.512,0,1.536,0,2.048-0.512C288.937,156.99,289.961,153.918,288.937,151.358z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M166.057,318.27l-6.144-12.8c-1.024-2.56-4.096-3.584-6.656-2.56c-2.56,1.024-3.584,4.096-2.56,6.656l6.144,12.8    c1.024,2.048,2.56,3.072,4.608,3.072c0.512,0,1.536,0,2.048-0.512C166.057,323.902,167.081,320.83,166.057,318.27z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M271.017,307.006l-14.336-2.56c-2.56-0.512-5.632,1.536-6.144,4.096c-0.512,2.56,1.536,5.632,4.096,6.144l14.336,2.56    c0.512,0,0.512,0,1.024,0c2.56,0,4.608-1.536,5.12-4.096C276.137,310.078,274.089,307.518,271.017,307.006z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M294.569,211.262l-14.336-2.56c-2.56-0.512-5.632,1.536-6.144,4.096c-0.512,2.56,1.536,5.632,4.096,6.144l14.336,2.56    c0.512,0,0.512,0,1.024,0c2.56,0,4.608-1.536,5.12-4.096C299.177,214.846,297.129,211.774,294.569,211.262z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M329.897,131.39l-14.336-2.56c-2.56-0.512-5.632,1.536-6.144,4.096c-0.512,3.072,1.536,5.632,4.096,6.144l14.336,2.56    c0.512,0,0.512,0,1.024,0c2.56,0,4.608-1.536,5.12-4.096C334.505,134.974,332.457,131.902,329.897,131.39z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M198.825,273.726l-6.144-12.8c-1.024-2.56-4.096-3.584-6.656-2.56c-2.56,1.024-3.584,4.096-2.56,6.656l6.144,12.8    c1.024,2.048,2.56,3.072,4.608,3.072c0.512,0,1.536,0,2.048-0.512C198.825,279.358,199.849,276.286,198.825,273.726z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M119.465,267.07c-1.536-2.048-5.12-2.56-7.168-0.512l-11.264,9.216c-2.048,1.536-2.56,5.12-0.512,7.168    c1.024,1.024,2.56,2.048,4.096,2.048c1.024,0,2.048-0.512,3.072-1.024l11.264-9.216    C121.001,272.702,121.513,269.63,119.465,267.07z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M260.777,159.038c-1.536-2.048-5.12-2.56-7.168-0.512l-11.264,8.704c-2.048,2.048-2.56,5.12-0.512,7.168    c1.024,1.024,2.56,2.048,4.096,2.048c1.024,0,2.048-0.512,3.072-1.024l11.264-9.216    C262.313,164.67,262.825,161.086,260.777,159.038z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M306.345,282.43c-1.536-2.048-5.12-2.56-7.168-0.512l-11.264,9.216c-2.048,1.536-2.56,5.12-0.512,7.168    c1.024,1.024,2.56,1.536,4.096,1.536c1.024,0,2.048-0.512,3.072-1.024l11.264-9.216    C307.881,288.062,308.393,284.478,306.345,282.43z"
                dataoriginal="#000000"
                fill="#272727"
                fillOpacity="0.15"
              />
            </g>
          </g>
        </g>
      </svg>
      <h1 className={props.className}>
        <Link to={routes.MAIN_PAGE} style={{ color: "#272727" }}>
          Pizza
        </Link>
      </h1>
    </>
  );
}
